import React from "react";
import { useTranslation } from "react-i18next";
import { RightClick } from "../../../assets/icons";

const WelcomeStep = () => {
  const { t } = useTranslation();
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 4fr", textAlign: "left" }}>
      <div></div>
      <p style={{ fontSize: "20px", fontWeight: "bold", margin: "0px" }}>{t("walkthrough.welcome.title")}</p>
      <RightClick style={{ justifySelf: "center" }} />
      <p style={{ margin: "0px", alignContent: "center" }}>{t("walkthrough.welcome.content")}</p>
    </div>
  );
};

export default WelcomeStep;
